export const formatMobile = (mobile) => {
  if (!mobile) return "";
  const mobileStr = mobile.toString();
  return mobileStr.startsWith("+92")
    ? mobileStr.replace("+92", "0")
    : mobileStr;
};
